module.exports = __webpack_public_path__ + "static/img/term-begins-banner.d56b78f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/term-begins-banner.png
// module id = AdnO
// module chunks = 0